import { Component, Injector, OnInit } from '@angular/core';
import { DialogBaseComponent } from "../../base-admin-panel/dialog-base/dialog-base.component";
import { GeocoderViewModel, SettingsService, TimezoneViewModel } from "../../../../services/settings.service";
import { LanguageModel, LanguageService } from "../../../../services/language.service";
import { TranslateService } from "@ngx-translate/core";
import { NewPasswordViewModel, UserCreateViewModel, UserViewModel, AccessRights, InterfacePermissions } from "../../../../services/users.service";
import { CompaniesService, CompanyModel } from 'app/services/companies.service';

//TODO:check if this model still used or NewPasswordViewModel is already everywhere
export class ChangePasswordViewModel {
  UserId: number;
  OldPassword: string = "";
  Password: string = "";
  PasswordConfirmation: string = "";
}

export class RoleViewModel {

  Value: number = 0;
  BitNumber: number = 0;
  CheckBit: number = 0;
  Name: string = "";
}

@Component({
  selector: 'app-users-dialog-base',
  templateUrl: './users-dialog-base.component.html',
  styleUrls: ['./users-dialog-base.component.css'],
  standalone: false
})
export class UsersDialogBaseComponent<T extends UserViewModel> extends DialogBaseComponent<T> implements OnInit {
  public geocoders: GeocoderViewModel[] = [];
  public languages: LanguageModel[] = [];
  public timezones: TimezoneViewModel[] = [];
  public users: UserViewModel[] = [];
  public roles: RoleViewModel[] = [];
  public openedTabName: string = "userData";

  public targetUser: UserViewModel;
  AccessRights = AccessRights;
  private languageService: LanguageService;
  private settingsService: SettingsService;
  private companyService: CompaniesService;
  protected translateService: TranslateService;
  private defaultRole: RoleViewModel;
  public companies: CompanyModel[];

  public openTab(name: string) {
    this.openedTabName = name;
  }

  public isSelected(name: string) {
    return name == this.openedTabName;
  }

  private GenerateRoles() {
    if (this.usersService.IsPermitted(AccessRights.EDIT_ALL_USERS)) {
      let role = new RoleViewModel();
      role.BitNumber = 24;
      role.CheckBit = 31;
      role.Value = 2147483647;
      role.Name = "Administrator";
      this.roles.push(role);
    }

    let role = new RoleViewModel();
    role.BitNumber = 16;
    role.CheckBit = 24;
    role.Value = 16777215;
    role.Name = "Integrator";
    this.roles.push(role);

    this.defaultRole = new RoleViewModel();
    this.defaultRole.BitNumber = 8;
    this.defaultRole.CheckBit = 16;
    this.defaultRole.Value = 65535;
    this.defaultRole.Name = "User";
    this.roles.push(this.defaultRole);

    role = new RoleViewModel();
    role.BitNumber = 4;
    role.CheckBit = 8;
    role.Value = 255;
    role.Name = "Demonstration";
    this.roles.push(role);

    role = new RoleViewModel();
    role.BitNumber = 2;
    role.CheckBit = 4;
    role.Value = 15;
    role.Name = "Observation";
    this.roles.push(role);
  }

  ngOnInit() {
    super.ngOnInit();
    this.GenerateRoles();
    //this.model.RoleDisplayName = this.defaultRole.Name;

    this.settingsService.getTimezones().subscribe(res => {
      this.timezones = res;
      if (this.model.TimeZone == "")
        this.model.TimeZone = this.timezones.find(tz => tz.Offset === 0).Name;
    });
    this.companyService.getCompanies().subscribe(res => {
      this.companies = res;
      if (this.model.CompanyId == 0)
        this.model.CompanyId = this.companies.find(c => c.Id == this.model.CompanyId).Id;
    });
    this.settingsService.getGeocoders().subscribe(res => {
      this.geocoders = res;
      this.model.Geocoder = this.geocoders[0].Name;
    });
    this.languageService.getLanguages().subscribe(res => {
      this.languages = res;
      this.model.Language = this.languageService.getLanguage().code;
    });
    const currentUser = this.usersService.getCurrentUser();
    if (this.model.Id == 0) {
      var superusers = this.getUsers();
      for (let i = 0; i < superusers.length; i++) {
        if (superusers[i].Id == currentUser.Id) {
          this.model.CompanyId = currentUser.Id;
          break;
        }
        if (superusers[i].Id == currentUser.CompanyId)
          this.model.CompanyId = currentUser.CompanyId;
      }

      this.model.InterfacePermissions = currentUser.InterfacePermissions;
    }
  }

  close(): void {
    super.close();
    this.openedTabName = "userData";
  }

  public isCheckboxAvailable() {
    return ((this.model.Acl & 256) != 0) && ((this.model.Acl & 65536) == 0);
  }

  public onChangeMask(event: Event) {
    const input = event.currentTarget as HTMLInputElement;
    this.model.Acl = Number(input.value);
  }
  public onChangeUnits(event: Event) {
    const value = (event.currentTarget as HTMLInputElement).value;
    if (value == "MILES")
      this.model.SetFlag("MILES");
    else
      this.model.ResetFlag("MILES");
  }
  public onChangeStartPage(event: Event) {
    const value = (event.currentTarget as HTMLInputElement).value;
    this.model.ResetFlag("START_DRIVERS");
    this.model.ResetFlag("START_FUEL");
    this.model.ResetFlag("START_REPORTS");
    this.model.ResetFlag("START_SERVICE");
    this.model.ResetFlag("START_ANALYTICS");
    this.model.ResetFlag("START_DISPATCHER");
    if (value != "")
      this.model.SetFlag(value);
  }

  public onToggleMask(bitNumber: number, event: Event) {
    const isOn = (event.target as HTMLInputElement).checked;
    this.toggleMask(isOn, bitNumber);
  }

  public toggleMask(isOn: boolean, bitNumber: number) {
    if (isOn)
      this.model.Acl = this.model.Acl | (1 << bitNumber);
    else
      this.model.Acl = this.model.Acl ^ (1 << bitNumber);
  }

  public onToggleInterfacePermissions(bitNumber: number, event: Event) {
    const isOn = (event.target as HTMLInputElement).checked;
    if (isOn)
      this.model.InterfacePermissions = this.model.InterfacePermissions | (1 << bitNumber);
    else
      this.model.InterfacePermissions = this.model.InterfacePermissions ^ (1 << bitNumber);
  }

  public InterfaceIsPermitted(bitNumber: InterfacePermissions) {
    return this.model.InterfaceIsPermitted(bitNumber);
  }

  public isRoleSelected(role: RoleViewModel) {
    return (this.model.Acl & (1 << role.CheckBit)) == 0 && (this.model.Acl & (1 << role.BitNumber)) != 0;
  }

  /*public resetPassword() {
    let message = this.translateService.instant("Password reset");
    if (!confirm(message + " " + this.model.Name + "?")) return;
    this.usersService.resetPassword(this.model.Id)
      .subscribe(() => {
        });
  }*/

  public isChecked(bitNumber: number) {
    return (this.model.Acl & (1 << bitNumber)) != 0;
  }

  constructor(protected injector: Injector) {
    super(injector);
    this.languageService = injector.get(LanguageService);
    this.settingsService = injector.get(SettingsService);
    this.translateService = injector.get(TranslateService);
    this.companyService = injector.get(CompaniesService);
  }

  changePassword() {
    let input = new NewPasswordViewModel();
    input.UserId = this.model.Id;
    input.Password = this.model.Password;
    input.PasswordConfirmation = this.model.PasswordConfirmation;
    this.usersService.changeUserPassword(input)
      .subscribe(() => {
        this.toastr.success(this.translateService.instant("Password successfully changed"));
      });
  }

  getUsers() {
    var users = this.users.filter(user => ((<UserViewModel>user).Acl & (1 << AccessRights.EDITUSERS)) != 0);

    if (this.targetUser)
      return users.filter(u => u.Id != this.targetUser.Id);
    else
      return users;
  }
}
